// src/PendingTicketCard.js
import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useSwipeable } from "react-swipeable";

const PendingTicketCard = ({ ticket, onAccept, onReject }) => {
  // Use a light green background for non-duplicates, light red for duplicates
  const backgroundColor = ticket.duplicate ? "#ffcccc" : "#ccffcc";

  // Configure swipe gestures
  const handlers = useSwipeable({
    onSwipedRight: () => {
      // Only allow accepting if not a duplicate
      if (!ticket.duplicate) {
        onAccept(ticket);
      }
    },
    onSwipedLeft: () => {
      onReject(ticket);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  return (
    <Box {...handlers} sx={{ marginBottom: 2 }}>
      <Card
        sx={{
          backgroundColor,
          padding: 2,
          textAlign: "center",
          fontFamily: "DibajFaNum, sans-serif",
        }}
      >
        <CardContent>
          <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={6}>
              <Typography variant="body2" align="center">
                <strong>زون:</strong> {ticket.seatInfo.zone.toUpperCase()}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" align="center">
                <strong>طبقه:</strong> {ticket.seatInfo.floor}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" align="center">
                <strong>ردیف:</strong> {ticket.seatInfo.row}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" align="center">
                <strong>شماره صندلی:</strong>{" "}
                {ticket.seatInfo.number.replace(/\D/g, "")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {ticket.duplicate && (
                <Typography variant="caption" color="error" align="center" sx={{ display: "block", mt: 1 }}>
                  این بلیط تکراری است!
                </Typography>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PendingTicketCard;
